import { Field, FieldProps, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useGetAllPendingStatusList } from "../../Parameters/Others/PendingStatus/api/getAllPendingStatusList";
import { useGetAllProvidersList } from "../../Parameters/Others/Providers/api/getAllProvidersList";
import { useGetAllSpeedsList } from "../../Parameters/Lines/Speeds/api/getAllSpeedsList";
import { useGetAllUsedByList } from "../../Parameters/Lines/UsedBy/api/getAllUsedByList";
import { useGetAllCostByList } from "../../Parameters/Lines/CostBy/api/getAllCostByList";
import UnitsSelectionDropdown from "src/components/Common/UI/UnitsSelectionDropdown/UnitsSelectionDropdown";
import { useGetAllLineTypesList } from "../../Parameters/Lines/LineTypes/api/getAllLineTypesList";


const EditLineForm = ({ initialValues, onSubmit, onBillingButtonClick, isBillingModalActive }: EditLineFormProps) => {
  const { t } = useTranslation();

  const getAllPendingStatusListQuery = useGetAllPendingStatusList();
  const getAllProvidersListQuery = useGetAllProvidersList();
  const getAllLineTypesListQuery = useGetAllLineTypesList()
  const getAllSpeedsListQuery = useGetAllSpeedsList(); 
  const getAllUsedByListQuery = useGetAllUsedByList(); 
  const getAllCostByListQuery = useGetAllCostByList(); 

  const validationSchema= Yup.object({
    cost:Yup.number().typeError('Το πεδίο πρέπει να είναι αριθμός'),
    endAUnitID: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    pendingStatusID: Yup.string().test({
      name: "exclusiveFields",
      exclusive: true,
      test: function(value) {
        const { usedByID } = this.parent;
        return !(value && usedByID && value.trim() !== "" && usedByID.trim() !== "");
      },
      message: "Επιλέξτε ένα απο τα δύο πεδία",
    }).test({
      name: "atLeastOneField",
      test: function(value) {
        const { usedByID } = this.parent;
        return value || usedByID;
      },
      message: "Τουλάχιστον ένα από τα πεδία 'Εκκρεμότητα' ή 'Χρήση Απο' πρέπει να επιλεγεί",
    }),
    usedByID: Yup.string().test({
      name: "exclusiveFields",
      exclusive: true,
      test: function(value) {
        const { pendingStatusID } = this.parent;
        return !(value && pendingStatusID && value.trim() !== "" && pendingStatusID.trim() !== "");
      },
      message: "Επιλέξτε ένα απο τα δύο πεδία",
    }).test({
      name: "atLeastOneField",
      test: function(value) {
        const { pendingStatusID } = this.parent;
        return value || pendingStatusID;
      },
      message: "Τουλάχιστον ένα από τα πεδία 'Εκκρεμότητα' ή 'Χρήση Απο' πρέπει να επιλεγεί",
    }),
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values, formikHelpers);
      }}
      validationSchema={validationSchema}
    >
      {({ errors, touched, isSubmitting, values, setFieldValue }) => (
        <Form>
          <Container fluid className="p-0">
          <Row>
            <Col xs={6}>
                <label className="form-label">
                  {`${t("Περιγραφή Γραμμής")}`}
                </label>
                <Field
                  name="descline"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="descline"
                 
                />
                <div className="text-danger">
                  {errors.descline && touched.descline && (
                    <div>{errors.descline}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("ID Number")}`}
                </label>
                <Field
                  name="hcNmsNum"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="hcNmsNum"
                 
                />
                <div className="text-danger">
                  {errors.hcNmsNum && touched.hcNmsNum && (
                    <div>{errors.hcNmsNum}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Αριθμός Αίτησης")}`}
                </label>
                <Field
                  name="applProtocolNumber"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="applProtocolNumber"
                 
                />
                <div className="text-danger">
                  {errors.applProtocolNumber && touched.applProtocolNumber && (
                    <div>{errors.applProtocolNumber}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                {t("Ημερομηνία Αίτησης")}
                </label>
                <Field 
                  name="applDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.applDate && touched.applDate && (
                    <div> {errors.applDate}</div>
                  )}
                </div>               
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Επίσημη Ημερομηνία Αίτησης")}
                </label>
                <Field 
                  name="offApplDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.offApplDate && touched.offApplDate && (
                    <div>{errors.offApplDate}</div>
                  )}
                </div>             
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Ημερομηνία Παράδοσης")}
                </label>
                <Field 
                  name="deliveryDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.deliveryDate && touched.deliveryDate && (
                    <div>{errors.deliveryDate}</div>
                  )}
                </div>             
              </Col>
              
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Εκκρεμότητα")}*`}
                </label>
                <Field
                  as="select"
                  name="pendingStatusID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="pendingStatusID"
                >
                <option value="">{t("Επιλέξτε Εκκρεμότητα")}</option>
                {getAllPendingStatusListQuery.data &&
                  getAllPendingStatusListQuery.data.map((pending) => (
                    <option key={pending.id} value={pending.id}>
                      {pending.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.pendingStatusID && touched.pendingStatusID && (
                    <div>{errors.pendingStatusID}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Πάροχος")}`}
                </label>
                <Field
                  as="select"
                  name="providerID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="providerID"
                >
                <option value="">{t("Επιλέξτε Πάροχο")}</option>
                {getAllProvidersListQuery.data &&
                  getAllProvidersListQuery.data.map((provider) => (
                    <option key={provider.id} value={provider.id}>
                      {provider.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.providerID && touched.providerID && (
                    <div>{errors.providerID}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Τύπος Γραμμής")}`}
                </label>
                <Field
                  as="select"
                  name="lineTypeID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="lineTypeID"
                >
                <option value="">{t("Επιλέξτε Τύπο Γραμμής")}</option>
                {getAllLineTypesListQuery.data &&
                  getAllLineTypesListQuery.data.map((lineType) => (
                    <option key={lineType.id} value={lineType.id}>
                      {lineType.description}
                    </option>
                  ))}
                
              </Field>
                <div className="text-danger">
                  {errors.lineTypeID && touched.lineTypeID && (
                    <div>{errors.lineTypeID}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Κωδικός SAP")}`}
                </label>
                <Field
                  name="sapCode"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="sapCode"
                 
                />
                <div className="text-danger">
                  {errors.sapCode && touched.sapCode && (
                    <div>{errors.sapCode}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Ταχύτητα")}`}
                </label>
                <Field
                  as="select"
                  name="speedID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="speedID"
                >
                <option value="">{t("Επιλέξτε Ταχύτητα")}</option>
                {getAllSpeedsListQuery.data &&
                  getAllSpeedsListQuery.data.map((speed) => (
                    <option key={speed.id} value={speed.id}>
                      {speed.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.speedID && touched.speedID && (
                    <div>{errors.speedID}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Χρήση Απο")}*`}
                </label>
                <Field
                  as="select"
                  name="usedByID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="usedByID"
                >
                <option value="">{t("Επιλέξτε Χρήση Από")}</option>
                {getAllUsedByListQuery.data &&
                  getAllUsedByListQuery.data.map((usedby) => (
                    <option key={usedby.id} value={usedby.id}>
                      {usedby.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.usedByID && touched.usedByID && (
                    <div>{errors.usedByID}</div>
                  )}
                </div>
              </Col>
              
              <Col xs={6} >
                <label className="form-label">
                  {t("Αριθμός Κλήσης")}
                </label>
                <div style={{ display: 'flex', alignItems: 'center' }}> 
                  <Field
                    type="text"
                    name="phoneNumber"
                    field="phoneNumber"
                    className="form-control"
                  />
                  <Button
                    type="button"
                    size="sm"
                    styletype="primary"
                    onClick={onBillingButtonClick}
                    className="py-2 px-2 w-25"
                    disabled={isBillingModalActive}
                  >
                    {t("Χρεώσεις")}
                    {isBillingModalActive && <Spinner size="sm" className="ms-1"/>}
                  </Button>
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Κόστος Ανα")}*`}
                </label>
                <Field
                  as="select"
                  name="costByID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="costByID"
                >
                <option value="">{t("Επιλέξτε Κόστος Ανα")}</option>
                {getAllCostByListQuery.data &&
                  getAllCostByListQuery.data.map((costby) => (
                    <option key={costby.id} value={costby.id}>
                      {costby.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.costByID && touched.costByID && (
                    <div>{errors.costByID}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Κόστος")}`}
                </label>
                <Field
                  name="cost"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="cost"
                 
                />
                <div className="text-danger">
                  {errors.cost && touched.cost && (
                    <div>{errors.cost}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}></Col>
              
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Εμπορική")}`}
                </label>
                <Field
                  type="checkbox"
                  name="isEmporiki"
                  field="isEmporiki"
                />
                <div className="text-danger">
                  {errors.isEmporiki && touched.isEmporiki && (
                    <div>{errors.isEmporiki}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Citibank")}`}
                </label>
                <Field
                  type="checkbox"
                  name="isCiti"
                  field="isCiti"
                />
                <div className="text-danger">
                  {errors.isCiti && touched.isCiti && (
                    <div>{errors.isCiti}</div>
                  )}
                </div>
              </Col>

              <Col xs="12">
                <hr />
              </Col>

              <UnitsSelectionDropdown errors={errors} touched={touched} field={"endAUnitID"} unitTypeLabel={"Α Άκρο*"} unitLabel={"-"} unitType={initialValues.endAUnitType} initialUnitID={initialValues.endAUnitID}/>
              

              <Col xs={6}></Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Ταχ.Διεύθυνση")}`}
                </label>
                <Field
                  name="endAAddress"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="endAAddress"
                  disabled
                />
                <div className="text-danger">
                  {errors.endAAddress && touched.endAAddress && (
                    <div>{errors.endAAddress}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}></Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Αριθμός Α Ζεύγους")}`}
                </label>
                <Field
                  name="coupleNumA1"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="coupleNumA1"
                 
                />
                <div className="text-danger">
                  {errors.coupleNumA1 && touched.coupleNumA1 && (
                    <div>{errors.coupleNumA1}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Αριθμός Β Ζεύγους")}`}
                </label>
                <Field
                  name="coupleNumB1"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="coupleNumB1"
                />
                <div className="text-danger">
                  {errors.coupleNumB1 && touched.coupleNumB1 && (
                    <div>{errors.coupleNumB1}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("HC Number")}`}
                </label>
                <Field
                  name="hcNum1"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="hcNum1"
                 
                />
                <div className="text-danger">
                  {errors.hcNum1 && touched.hcNum1 && (
                    <div>{errors.hcNum1}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Αριθμός Λογαριασμού")}`}
                </label>
                <Field
                  name="accNum1"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="accNum1"
                 
                />
                <div className="text-danger">
                  {errors.accNum1 && touched.accNum1 && (
                    <div>{errors.accNum1}</div>
                  )}
                </div>
              </Col>

              <Col xs="12">
                <hr />
              </Col>

              <UnitsSelectionDropdown errors={errors} touched={touched} field={"endBUnitID"} unitTypeLabel={"B Άκρο"} unitLabel={"-"} unitType={initialValues.endBUnitType} initialUnitID={initialValues.endBUnitID}/>

              <Col xs={6}></Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Ταχ.Διεύθυνση")}`}
                </label>
                <Field
                  name="endBAddress"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="endBAddress"
                  disabled
                />
                <div className="text-danger">
                  {errors.endBAddress && touched.endBAddress && (
                    <div>{errors.endBAddress}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}></Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Αριθμός Α Ζεύγους")}`}
                </label>
                <Field
                  name="coupleNumA2"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="coupleNumA2"
                 
                />
                <div className="text-danger">
                  {errors.coupleNumA2 && touched.coupleNumA2 && (
                    <div>{errors.coupleNumA2}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Αριθμός Β Ζεύγους")}`}
                </label>
                <Field
                  name="coupleNumB2"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="coupleNumB2"
                 
                />
                <div className="text-danger">
                  {errors.coupleNumB2 && touched.coupleNumB2 && (
                    <div>{errors.coupleNumB2}</div>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("HC Number")}`}
                </label>
                <Field
                  name="hcNum2"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="hcNum2"
                 
                />
                <div className="text-danger">
                  {errors.hcNum2 && touched.hcNum2 && (
                    <div>{errors.hcNum2}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Αριθμός Λογαριασμού")}`}
                </label>
                <Field
                  name="accNum2"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="accNum2"
                  
                />
                <div className="text-danger">
                  {errors.accNum2 && touched.accNum2 && (
                    <div>{errors.accNum2}</div>
                  )}
                </div>
              </Col>

              <Col xs="12">
                <hr />
              </Col>


              <Col xs={6}>
                <label className="form-label">
                {t("Ημερομηνία Διαγραφής")}
                </label>
                <Field 
                  name="removalDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.removalDate && touched.removalDate && (
                    <div> {errors.removalDate}</div>
                  )}
                </div>               
              </Col>

              <Col xs={6} className="d-none">
                <label className="form-label">
                  {`${t("Τύπος Γραμμής από CD")}`}
                </label>
                <Field
                  name="CDLineType"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="CDLineType"
                  disabled
                />
                <div className="text-danger">
                  {errors.CDLineType && touched.CDLineType && (
                    <div>{errors.CDLineType}</div>
                  )}
                </div>
              </Col>

             

              <Col xs={6} className="d-none">
                <label className="form-label">
                  {`${t("Διεύθυνση A από CD")}`}
                </label>
                <Field
                  name="CDAddressA"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="CDAddressA"
                  disabled
                />
                <div className="text-danger">
                  {errors.CDAddressA && touched.CDAddressA && (
                    <div>{errors.CDAddressA}</div>
                  )}
                </div>
              </Col>

              <Col xs={6} className="d-none">
                <label className="form-label">
                  {`${t("Διεύθυνση Β από CD")}`}
                </label>
                <Field
                  name="CDAddressB"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="CDAddressB"
                  disabled
                />
                <div className="text-danger">
                  {errors.CDAddressB && touched.CDAddressB && (
                    <div>{errors.CDAddressB}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Σχόλια Διαγραφής")}`}
                </label>
                <Field
                  name="removalComment"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="removalComment"
                  as="textarea"
                />
                <div className="text-danger">
                  {errors.removalComment && touched.removalComment && (
                    <div>{errors.removalComment}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Σχόλια")}`}
                </label>
                <Field
                  name="comments"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="comments"
                  as="textarea"
                />
                <div className="text-danger">
                  {errors.comments && touched.comments && (
                    <div>{errors.comments}</div>
                  )}
                </div>
              </Col>

            </Row>
          </Container>

          <div className="mb-3">
            <Button
              type="submit"
              size="sm"
              styletype="primary"
              disabled={isSubmitting}
            >
              {t("Αποθήκευση")}
            </Button>
          </div>
        </Form>
    )}
    </Formik>
)
}
export default EditLineForm;

type EditLineFormProps =
  | {
      initialValues: IEditLineForm;
      onSubmit: (
        values: IEditLineForm,
        formikHelpers: FormikHelpers<IEditLineForm>
      ) => void;
      onBillingButtonClick: () => void;
      isBillingModalActive: boolean;
    }
